<button
  nz-button
  [nzBlock]="fullSize"
  nzSize="large"
  [title]="'NEGOTIATIONS.START_PRICE' | translate"
  (click)="openLotNegotiationsPriceFormModal()"
>
  <i nz-icon nzType="interaction" nzTheme="outline"></i>
  <span *ngIf="fullSize">
    {{ 'NEGOTIATIONS.START_PRICE' | translate }}
  </span>
</button>
